import React from 'react'
import styles from "./style.module.scss"
import Confetti from 'react-confetti'
import useWindowSize from '../../hooks/useWindowSize'

const ConfettiC: React.FC = () => {
   const { width, height } = useWindowSize()

   return (
      <>
         <Confetti
            width={width}
            height={height}
            numberOfPieces={900}
            recycle={false}
         />
         <Confetti
            width={width}
            height={height}
            numberOfPieces={200}
            recycle={true}
         />
      </>
   )
}

export default ConfettiC